// extracted by mini-css-extract-plugin
export default {"container":"IngredientItem_container__64T0H","count":"IngredientItem_count__BQycW","image":"IngredientItem_image__VaZfd"};